import App from './App';

import React from 'react';
import ReactDOM from 'react-dom/client';

import '@amigoapp/doca/dist/css/doca.min.css';
import './index.scss';

const Root = ReactDOM.createRoot(document.getElementById('root'));

Root.render(<App />);
